import api from '@seller-hermes/utils/api';
import {
  SellerGroupSearchResponse,
  SellerGroupUser,
  SellerGroupUserRole,
} from './seller-group.types';

export class SellerGroupService {
  static async getSellerGroupUser() {
    return api.get<SellerGroupUser>('/me').then((res) => res.data);
  }
  static async searchRoles() {
    return api
      .post<SellerGroupSearchResponse<SellerGroupUserRole>>(`/v4/search/roles`)
      .then((res) => res.data);
  }
}
